<template lang="pug">
  div#settings
    navigation(ns="settings" :routes="routes")
    router-view
</template>

<script>
  import Navigation from '@/components/Navigation'
  import routes from '@/routes/settings'
  export default {
    name: 'Settings',
    components: {
      Navigation
    },
    data () {
      return {
        routes
      }
    }
  }
</script>

<style lang="sass"></style>
